import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuotationService {


  url = environment.serverAPI5 + "/api/quotes";

  constructor(private http: HttpClient) { }

  getAllQuotation(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllQuotationDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getQuotationById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEditQuotation(warehouses: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, warehouses);
  }

  QuotationSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }
  deleteByQuotesId(quotesId: any): Observable<Object> {
    return this.http.delete(`${this.url}/${quotesId}`);
  }
  downloadQuotesTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }
  deleteImage(data: any): Observable<Object> {
    return this.http.post(`${this.url}/deleteImage`, data);
  }
  downloadQuotationReport(Page: number, size: number, sort, selectionQuotes): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
      &size=${size}&sort=${sort}`, selectionQuotes, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }


}

